// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, Lazy]);

/**
 * Swiper configurations
 */

export default () => {
  (function($, undefined) {

    // Whitepapers slider
    new SwiperCore('.whitepapers-slider', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      speed: 300,
      spaceBetween: 30,
      slidesPerView: 1.1,
      navigation: false,
      pagination: {
        el: '.slider-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 30,
        },
        576: {
          slidesPerView: 1.4,
          spaceBetween: 30,
        },
      },
    });

    // Articles slider
    new SwiperCore('.articles-slider', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      speed: 300,
      spaceBetween: 30,
      slidesPerView: 1.1,
      navigation: false,
      pagination: {
        el: '.slider-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 30,
        },
        576: {
          slidesPerView: 1.4,
          spaceBetween: 30,
        },
      },
    });

  })(jQuery);
}

